module.exports = __webpack_public_path__ + "img/norte-classic-prime-preview.217bf1a7.png";